import { useState } from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import { LockScreen } from "./components/LockScreen";
import EarlyAccessLayout from "./pages/early-access/EarlyAccessLayout";
import Disclosure from "./pages/early-access/Disclosure";
import Consent from "./pages/early-access/Consent";
import Done from "./pages/early-access/Done";
import Welcome from "./pages/early-access/Welcome";

function App() {
  const [isLocked, setIsLocked] = useState(false);

  if (isLocked) {
    return <LockScreen onUnlock={() => setIsLocked(false)} />;
  }

  return (
    <div className="h-auto min-h-0 bg-thema-black text-thema-gray-1 overflow-x-hidden overflow-y-visible w-full max-w-[100vw] lg:min-h-screen">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/early-access" element={<EarlyAccessLayout />}>
          <Route index element={<Disclosure />} />
          <Route path="consent" element={<Consent />} />
          <Route path="done" element={<Done />} />
        </Route>
        {/* React Router v7 only treats `:name` as a param when preceded by `/`, so
            we capture the whole slug here and validate `welcome-:address` inside. */}
        <Route path="/:welcomeSlug" element={<EarlyAccessLayout />}>
          <Route index element={<Welcome />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;

